import { IOutfitState } from 'types/outfit';

export default function fetchOutfitSuccess(state: IOutfitState, payload: any) {
  return {
    ...state,
    ...payload.reduce(reduceFn, {}),
    isChanging: false,
  };
}

function reduceFn(acc: {[key: string]: number }, next: { name: string, qualityId: number }) {
  const { name, qualityId: id } = next;
  return { ...acc, [name]: id };
}